import { createApiRef } from '@backstage/frontend-plugin-api';
import { Cluster } from '@internal/backstage-plugin-catalog-devops-common';
import { DefaultApiResponse } from '@internal/backstage-plugin-devops-react';

export const clustersApiRef = createApiRef<ClustersApi>().with({
  id: 'clusters-api',
  pluginId: 'catalog-devops-module-clusters',
});

export interface ClustersApi {
  createClusterEntity(data: Cluster): Promise<DefaultApiResponse>;
  editClusterEntity(id: string, data: Cluster): Promise<DefaultApiResponse>;
  deleteClusterEntity(id: string): Promise<DefaultApiResponse>;
  triggerProvider(providerType: string): Promise<DefaultApiResponse>;
}
